import React from "react";
import {EditGuesser} from "@api-platform/admin";

const AirlineInfoEdit = props => (
        <EditGuesser {...props} resource="covid19-airline-infos"/>
);

export default AirlineInfoEdit;
